import ConfirmationModal from "../../common_nextgen/common_components/Modal/ConfirmationModal";
import NextGenPaginator from "../../common_nextgen/common_components/Pagination/NextGenPaginator";
import ButtonsSection from "../../common_nextgen/common_components/SearchScreenComponents/ButtonsSection";
import DisplayTable from "../../common_nextgen/common_components/SearchScreenComponents/DisplayTable";
import SearchBox from "../../common_nextgen/common_components/SearchScreenComponents/SearchBox";
import useAdditionalPatientPaySteps from "./hooks/useAdditionalPatientPaySteps";

const AdditionalPatientPaySteps = ({
  onSelect,
  hideModal,
  params,
  selectMode,
  lookupType,
  schedule,
  scheduleDesc,
  setFalg,
  onNavigate,
}) => {
  const additionalPatientPayStepsData = useAdditionalPatientPaySteps(
    onSelect,
    hideModal,
    params,
    selectMode,
    lookupType,
    schedule,
    scheduleDesc,
    setFalg,
    onNavigate
  );

  return (
    <div class="container container-fluid">
      <ButtonsSection
        ctaButtons={additionalPatientPayStepsData.leftButtons}
        align="left"
      />
      <div className="header-section">
        <h1>
          {additionalPatientPayStepsData.screen_title} -{" "}
          <span className="heading-cod">
            {additionalPatientPayStepsData.screenNumber}
          </span>
        </h1>
      </div>
      <SearchBox
        formFields={additionalPatientPayStepsData.formFields}
        dropdownValues={additionalPatientPayStepsData.dropdownValues}
        paramsData={additionalPatientPayStepsData.paramsData}
        updataParamData={additionalPatientPayStepsData.updateParamData}
      />
      <ButtonsSection ctaButtons={additionalPatientPayStepsData.ctaButtons} />
      <DisplayTable
        data={additionalPatientPayStepsData.data}
        parmKey={additionalPatientPayStepsData.parmKey}
        menuOptions={additionalPatientPayStepsData.menuOptions}
        tableHeaders={additionalPatientPayStepsData.columnDef}
        setRowData={additionalPatientPayStepsData.setRowData}
        selectedPriceSchedules={additionalPatientPayStepsData.selectedRows}
        setSelectedPriceSchedules={
          additionalPatientPayStepsData.setSelectedRows
        }
        selectMode={selectMode}
      />
      <div className="paginator-container">
        <NextGenPaginator
          selectMode={additionalPatientPayStepsData.selectMode}
          first={additionalPatientPayStepsData.first}
          rows={additionalPatientPayStepsData.rows}
          totalRecords={additionalPatientPayStepsData.totalRecords}
          currentPage={additionalPatientPayStepsData.currentPage}
          rowsPerPageOptions={[10, 25, 50]}
          onPageChange={additionalPatientPayStepsData.onPageChange}
        />
      </div>
      {additionalPatientPayStepsData.isConfirmationModalOpen && (
        <ConfirmationModal
          isOpen={additionalPatientPayStepsData.isConfirmationModalOpen}
          onRequestClose={additionalPatientPayStepsData.closeConfirmationModal}
          onBack={additionalPatientPayStepsData.closeConfirmationModal}
          onSave={additionalPatientPayStepsData.deleteAdditionalPatientPaySteps}
          confirmLabel="Confirm(Y/N)"
          options={[
            { label: "N-No", value: "no" },
            { label: "Y-Yes", value: "yes" },
          ]}
          setSelectedOption={additionalPatientPayStepsData.setSelectedOption}
        />
      )}
    </div>
  );
};

export default AdditionalPatientPaySteps;
